import React, { useState } from "react";
import "./AppointmentScheduler.css";
import logo2 from "./logo2.png";
import OutpatientNavigator from "./OutpatientNavigator";
import { useNavigate } from "react-router-dom";

const appointments = [
  {
    id: 1,
    time: "8:00 AM",
    patient: "Sarah Johnson",
    dob: "04/22/1970",
    visit: "Follow-up",
    duration: "30 min",
    status: "Completed",
    interactive: false,
  },
  {
    id: 2,
    time: "8:30 AM",
    patient: "Michael Chen",
    dob: "01/14/1966",
    visit: "Diabetes Management",
    duration: "30 min",
    status: "Completed",
    interactive: false,
  },
  {
    id: 3,
    time: "9:00 AM",
    patient: "Emily Davis",
    dob: "07/02/1981",
    visit: "Cardiology Follow-up",
    duration: "30 min",
    status: "Waiting",
    interactive: false,
  },
  {
    id: 4,
    time: "9:30 AM",
    patient: "John Smith",
    dob: "02/14/1978",
    visit: "Annual Wellness Visit",
    duration: "30 min",
    status: "Ready",
    interactive: true,
  },
  {
    id: 5,
    time: "10:00 AM",
    patient: "Lisa Martinez",
    dob: "09/10/1986",
    visit: "New Patient Consultation",
    duration: "45 min",
    status: "Scheduled",
    interactive: false,
  },
];

export default function AppointmentScheduler() {
  const [selectedPatient, setSelectedPatient] = useState(null);

  const navigate = useNavigate();

  const handleNavigateToReports = () => navigate("/patient-list");
  const handleNavigateToMonitor = () => navigate("/video-wall");

  if (selectedPatient) {
    return (
      <OutpatientNavigator
        patient={selectedPatient}
        onBack={() => setSelectedPatient(null)}
      />
    );
  }

  return (
    <div className="scheduler-page">
      {/* HEADER */}
      <div className="scheduler-header">
        <img src={logo2} alt="Verge Nursing" />

        <div className="scheduler-header-text">
          <h1>Ambulatory Care Scheduler</h1>
          <p>Virtual Care Clinic</p>
        </div>
      </div>
      {/* Top Nav */}
      <div className="top-nav-buttons">
        <button onClick={handleNavigateToReports} className="top-nav-btn">
          Inpatient Census
        </button>
        <button onClick={handleNavigateToMonitor} className="top-nav-btn">
          Monitor Rooms
        </button>
        </div>

      {/* KPI CARDS */}
      <div className="scheduler-stats">
        <div className="stat-card">
          <div className="stat-number">5</div>
          <div className="stat-label">Today's Visits</div>
        </div>

        <div className="stat-card waiting">
          <div className="stat-number">1</div>
          <div className="stat-label">Waiting Room</div>
        </div>

        <div className="stat-card ready">
          <div className="stat-number">1</div>
          <div className="stat-label">Ready for Visit</div>
        </div>

        <div className="stat-card completed">
          <div className="stat-number">2</div>
          <div className="stat-label">Completed</div>
        </div>
      </div>

      {/* MAIN LAYOUT */}
      <div className="scheduler-layout">
        {/* LEFT SIDEBAR */}
        <div className="scheduler-sidebar">
          <div className="sidebar-card">
            <h3>Today's Providers</h3>

            <div className="provider-item active">
              <div className="provider-avatar">JH</div>
              <div>
                <strong>James Halpert, MD</strong>
                <p>Primary Care</p>
              </div>
            </div>

            <div className="provider-item">
              <div className="provider-avatar secondary">SJ</div>
              <div>
                <strong>Sarah Jones, NP</strong>
                <p>Primary Care</p>
              </div>
            </div>

            <div className="provider-item">
              <div className="provider-avatar secondary">MP</div>
              <div>
                <strong>Michael Patel, MD</strong>
                <p>Internal Medicine</p>
              </div>
            </div>
          </div>

          <div className="sidebar-card">
            <h3>Clinic Information</h3>

            <div className="info-row">
              <span>Clinic</span>
              <strong>Virtual Primary Care</strong>
            </div>

            <div className="info-row">
              <span>Location</span>
              <strong>Medical Office Building</strong>
            </div>

            <div className="info-row">
              <span>Date</span>
              <strong>Wednesday, July 16</strong>
            </div>

            <div className="info-row">
              <span>Session</span>
              <strong>Morning Clinic</strong>
            </div>
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div className="scheduler-main">
          {/* TABLE CARD */}
          <div className="schedule-card">
            <div className="schedule-card-header">
              <h2>Provider Schedule</h2>
              <div className="schedule-filters">
                <span>Today</span>
                <span>Virtual Visits</span>
              </div>
            </div>

            <table className="schedule-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Patient</th>
                  <th>DOB</th>
                  <th>Visit Type</th>
                  <th>Duration</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {appointments.map((appt) => (
                  <tr
                    key={appt.id}
                    className={appt.interactive ? "clickable active-row" : ""}
                    onClick={() =>
                      appt.interactive && setSelectedPatient(appt)
                    }
                  >
                    <td className="time-cell">
                      {appt.time}
                    </td>

                    <td className="patient-cell">
                      <div className="patient-info">
                        <div className="patient-avatar-small">
                          {appt.patient
                            .split(" ")
                            .map((n) => n[0])
                            .join("")}
                        </div>

                        <div>
                          <strong>{appt.patient}</strong>
                          {appt.interactive && (
                            <small>Virtual visit available</small>
                          )}
                        </div>
                      </div>
                    </td>

                    <td>{appt.dob}</td>
                    <td>{appt.visit}</td>
                    <td>{appt.duration}</td>

                    <td>
                      <span
                        className={`status ${appt.status
                          .replace(/\\s/g, "")
                          .toLowerCase()}`}
                      >
                        {appt.status === "Completed" && "✓ Completed"}
                        {appt.status === "Waiting" && "◐ Waiting Room"}
                        {appt.status === "Ready" && "● Ready for Visit"}
                        {appt.status === "Scheduled" && "○ Scheduled"}
                      </span>
                    </td>

                    <td>
                      {appt.interactive ? (
                        <button
                          className="open-chart-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedPatient(appt);
                          }}
                        >
                          Open Chart
                        </button>
                      ) : (
                        <span className="view-link">View</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}